import { useState } from "react";
import Swal from "sweetalert2";
import { liberarEspacioCacheBac } from "../../hooks/useSync";

/**
 * Botón para cuando el dispositivo se queda sin espacio. Borra SOLO
 * caché re-descargable (visitas, catálogos, PAI, MRCV guardados para
 * ver sin conexión, y los archivos de la app) — nunca toca la cola de
 * pendientes sin sincronizar, esa tiene su propio botón (con su propia
 * advertencia) en "Ver pendientes".
 *
 * Móntalo una sola vez, siempre visible — por ejemplo en el pie de
 * BacSarampionHome.jsx, junto a la versión de la app.
 */
export default function LiberarEspacioBac() {
  const [limpiando, setLimpiando] = useState(false);

  const liberarEspacio = async () => {
    const confirmado = await Swal.fire({
      icon: "question",
      title: "¿Liberar espacio?",
      html: `Esto borra la copia local de lo que ya está guardado en el servidor (viviendas, catálogos, PAI, MRCV) — se vuelve a descargar sola la próxima vez que la necesites.<br/><br/><strong>Tus formularios sin sincronizar NO se tocan</strong> — eso sigue intacto, esperando su turno para subir.`,
      showCancelButton: true, confirmButtonText: "Sí, liberar espacio", cancelButtonText: "Cancelar",
      confirmButtonColor: "#16342a",
    });
    if (!confirmado.isConfirmed) return;

    setLimpiando(true);
    try {
      await liberarEspacioCacheBac();
      Swal.fire({ icon: "success", title: "Espacio liberado", timer: 1800, showConfirmButton: false });
    } catch (e) {
      Swal.fire("No se pudo liberar todo", "Intenta de nuevo en un momento.", "warning");
    } finally {
      setLimpiando(false);
    }
  };

  return (
    <button onClick={liberarEspacio} disabled={limpiando}
      title="Borra solo la copia local re-descargable — tus formularios sin sincronizar quedan intactos"
      style={{
        background: "none", border: "1px solid #dee2e6", color: "#6c757d",
        borderRadius: 6, padding: "4px 10px", fontSize: 11, fontWeight: 600,
        cursor: limpiando ? "not-allowed" : "pointer", opacity: limpiando ? 0.6 : 1,
      }}>
      {limpiando ? "Liberando..." : "Liberar espacio"}
    </button>
  );
}
